// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2d-6";
export var headerCell = "_2d-2";
export var loadingStateContent = "_2d-8";
export var rowWrapper = "_2d-4";
export var stickyAggregationCell = "_2d-b";
export var stickyAggregationRow = "_2d-7";
export var stickyColumnCell = "_2d-a";
export var stickyColumnHeaderCell = "_2d-9";
export var table = "_2d-1";
export var virtualRowWrapper = "_2d-5";
export var virtualTableContainer = "_2d-0";
export var white = "_2d-3";